// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import {
  Count,
  CountFromJSON,
  CountToJSON,
  DefaultResponseError,
  DefaultResponseErrorFromJSON,
  DefaultResponseErrorToJSON,
  ForbiddenError,
  ForbiddenErrorFromJSON,
  ForbiddenErrorToJSON,
  Release,
  ReleaseFromJSON,
  ReleaseToJSON,
  ReleaseMinified,
  ReleaseMinifiedFromJSON,
  ReleaseMinifiedToJSON,
  ReleasePayload,
  ReleasePayloadFromJSON,
  ReleasePayloadToJSON,
  ReleaseReadiness,
  ReleaseReadinessFromJSON,
  ReleaseReadinessToJSON,
} from "../models";

export interface AddReleaseRequest {
  releasePayload?: ReleasePayload;
}

export interface CountReleasesRequest {
  project: number;
  status?: CountReleasesStatusEnum;
}

export interface DeleteReleaseRequest {
  id: number;
  project: number;
}

export interface EditReleaseRequest {
  id: number;
  releasePayload?: ReleasePayload;
}

export interface GetReleaseRequest {
  id: number;
}

export interface GetReleaseReadinessRequest {
  id: number;
}

export interface GetReleaseReadinessByTokenRequest {
  token: string;
}

export interface GetReleasesRequest {
  project: number;
  limit?: number;
  start?: number;
  sort?: string;
  filter?: string;
  status?: GetReleasesStatusEnum;
}

/**
 * no description
 */
export class ReleasesApi extends runtime.BaseAPI {
  /**
   * Creates a new release
   * Create a release
   */
  async addReleaseRaw(
    requestParameters: AddReleaseRequest
  ): Promise<runtime.ApiResponse<ReleaseMinified>> {
    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/releases`,
      method: "POST",
      headers: headerParameters,
      query: queryParameters,
      body: ReleasePayloadToJSON(requestParameters.releasePayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ReleaseMinifiedFromJSON(jsonValue)
    );
  }

  /**
   * Creates a new release
   * Create a release
   */
  async addRelease(
    requestParameters: AddReleaseRequest
  ): Promise<ReleaseMinified> {
    const response = await this.addReleaseRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get count of releases for a specific project
   * Count releases
   */
  async countReleasesRaw(
    requestParameters: CountReleasesRequest
  ): Promise<runtime.ApiResponse<Count>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling countReleases."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.status !== undefined) {
      queryParameters["status"] = requestParameters.status;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/releases/count`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CountFromJSON(jsonValue)
    );
  }

  /**
   * Get count of releases for a specific project
   * Count releases
   */
  async countReleases(requestParameters: CountReleasesRequest): Promise<Count> {
    const response = await this.countReleasesRaw(requestParameters);
    return await response.value();
  }

  /**
   * Deletes a specific release. Does not delete associated test plans.
   * Delete a release
   */
  async deleteReleaseRaw(
    requestParameters: DeleteReleaseRequest
  ): Promise<runtime.ApiResponse<any>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling deleteRelease."
      );
    }

    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling deleteRelease."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/releases/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "DELETE",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.TextApiResponse(response);
  }

  /**
   * Deletes a specific release. Does not delete associated test plans.
   * Delete a release
   */
  async deleteRelease(requestParameters: DeleteReleaseRequest): Promise<any> {
    const response = await this.deleteReleaseRaw(requestParameters);
    return await response.value();
  }

  /**
   * Edits a specific release
   * Edit a release
   */
  async editReleaseRaw(
    requestParameters: EditReleaseRequest
  ): Promise<runtime.ApiResponse<ReleaseMinified>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling editRelease."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/releases/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "PUT",
      headers: headerParameters,
      query: queryParameters,
      body: ReleasePayloadToJSON(requestParameters.releasePayload),
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ReleaseMinifiedFromJSON(jsonValue)
    );
  }

  /**
   * Edits a specific release
   * Edit a release
   */
  async editRelease(
    requestParameters: EditReleaseRequest
  ): Promise<ReleaseMinified> {
    const response = await this.editReleaseRaw(requestParameters);
    return await response.value();
  }

  /**
   * Get details of a specific release
   * Get release
   */
  async getReleaseRaw(
    requestParameters: GetReleaseRequest
  ): Promise<runtime.ApiResponse<Release>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getRelease."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/releases/{id}`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ReleaseFromJSON(jsonValue)
    );
  }

  /**
   * Get details of a specific release
   * Get release
   */
  async getRelease(requestParameters: GetReleaseRequest): Promise<Release> {
    const response = await this.getReleaseRaw(requestParameters);
    return await response.value();
  }

  /**
   * Returns aggregated readiness data for a release including execution summary, open defects, coverage by suite, evidence metrics, comparison to previous release, and a computed Go/No-Go verdict. Uses the latest run (regression) of each test plan in the release; `run_history` adds the same execution counts over every run.
   * Get release readiness dashboard data
   */
  async getReleaseReadinessRaw(
    requestParameters: GetReleaseReadinessRequest
  ): Promise<runtime.ApiResponse<ReleaseReadiness>> {
    if (requestParameters.id === null || requestParameters.id === undefined) {
      throw new runtime.RequiredError(
        "id",
        "Required parameter requestParameters.id was null or undefined when calling getReleaseReadiness."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/releases/{id}/readiness`.replace(
        `{${"id"}}`,
        encodeURIComponent(String(requestParameters.id))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ReleaseReadinessFromJSON(jsonValue)
    );
  }

  /**
   * Returns aggregated readiness data for a release including execution summary, open defects, coverage by suite, evidence metrics, comparison to previous release, and a computed Go/No-Go verdict. Uses the latest run (regression) of each test plan in the release; `run_history` adds the same execution counts over every run.
   * Get release readiness dashboard data
   */
  async getReleaseReadiness(
    requestParameters: GetReleaseReadinessRequest
  ): Promise<ReleaseReadiness> {
    const response = await this.getReleaseReadinessRaw(requestParameters);
    return await response.value();
  }

  /**
   * Public endpoint (no authentication required). Returns the same readiness data as the authenticated endpoint, looked up by the release's public_token. Only works if is_public is true on the release.
   * Get release readiness by public token
   */
  async getReleaseReadinessByTokenRaw(
    requestParameters: GetReleaseReadinessByTokenRequest
  ): Promise<runtime.ApiResponse<ReleaseReadiness>> {
    if (
      requestParameters.token === null ||
      requestParameters.token === undefined
    ) {
      throw new runtime.RequiredError(
        "token",
        "Required parameter requestParameters.token was null or undefined when calling getReleaseReadinessByToken."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request({
      path: `/releases/readiness/{token}`.replace(
        `{${"token"}}`,
        encodeURIComponent(String(requestParameters.token))
      ),
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ReleaseReadinessFromJSON(jsonValue)
    );
  }

  /**
   * Public endpoint (no authentication required). Returns the same readiness data as the authenticated endpoint, looked up by the release's public_token. Only works if is_public is true on the release.
   * Get release readiness by public token
   */
  async getReleaseReadinessByToken(
    requestParameters: GetReleaseReadinessByTokenRequest
  ): Promise<ReleaseReadiness> {
    const response = await this.getReleaseReadinessByTokenRaw(
      requestParameters
    );
    return await response.value();
  }

  /**
   * Get releases for a specific project
   * Get releases
   */
  async getReleasesRaw(
    requestParameters: GetReleasesRequest
  ): Promise<runtime.ApiResponse<Array<Release>>> {
    if (
      requestParameters.project === null ||
      requestParameters.project === undefined
    ) {
      throw new runtime.RequiredError(
        "project",
        "Required parameter requestParameters.project was null or undefined when calling getReleases."
      );
    }

    const queryParameters: runtime.HTTPQuery = {};

    if (requestParameters.project !== undefined) {
      queryParameters["project"] = requestParameters.project;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["_limit"] = requestParameters.limit;
    }

    if (requestParameters.start !== undefined) {
      queryParameters["_start"] = requestParameters.start;
    }

    if (requestParameters.sort !== undefined) {
      queryParameters["_sort"] = requestParameters.sort;
    }

    if (requestParameters.filter !== undefined) {
      queryParameters["_filter"] = requestParameters.filter;
    }

    if (requestParameters.status !== undefined) {
      queryParameters["status"] = requestParameters.status;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["Authorization"] =
        this.configuration.apiKey("Authorization"); // bearerAuth authentication
    }

    const response = await this.request({
      path: `/releases`,
      method: "GET",
      headers: headerParameters,
      query: queryParameters,
    });

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(ReleaseFromJSON)
    );
  }

  /**
   * Get releases for a specific project
   * Get releases
   */
  async getReleases(
    requestParameters: GetReleasesRequest
  ): Promise<Array<Release>> {
    const response = await this.getReleasesRaw(requestParameters);
    return await response.value();
  }
}

/**
 * @export
 * @enum {string}
 */
export enum CountReleasesStatusEnum {
  Planned = "planned",
  InProgress = "in_progress",
  Ready = "ready",
  Shipped = "shipped",
  Blocked = "blocked",
}
/**
 * @export
 * @enum {string}
 */
export enum GetReleasesStatusEnum {
  Planned = "planned",
  InProgress = "in_progress",
  Ready = "ready",
  Shipped = "shipped",
  Blocked = "blocked",
}
